/**
 * Created by Florin David on 09/01/2017.
 */
import superagent from 'superagent'

import env from 'config/env'
import localStorage from './local-storage'
import appVersion from './version'
import browserSessionId from 'lib/browser-sessionId'
import sessionId from 'lib/sessionId'
import { getLocale } from 'selectors/intl'
import { getToken } from 'selectors/auth'

const environment = env.NODE_ENV
// const token = env.LOGGER_TOKEN
const app = env.LOGGER_APP
const module = env.LOGGER_MODULE
const site = env.LOGGER_SITE
const url = env.LOGGER_URL

enum LogLevel {
  info = 'info',
  debug = 'debug',
  error = 'error',
}

interface LogParams {
  level: LogLevel
  message: string
  params?: Record<string, unknown>
  offline?: boolean
  version?: string
  sendQueuedMessages?: boolean
}

interface UserData {
  email: string
}

interface TenantData {
  name: string
}

export interface LogObject {
  level: LogLevel
  message: string
  offline: boolean
  version: string
  module: string
  site: string
  environment: string
  createdAt: string
  app: string
  user?: UserData
  tenant?: TenantData
  client: {
    userAgent: string
  }
  params: {
    browserSessionId: string
    sessionId: string
    location?: RouterLocation
    language: string
    state?: string
  }
}

const getUserData = (): UserData | undefined => {
  // if (typeof getState !== 'function') {
  //   return undefined
  // }
  //
  // const user = getState().user
  //
  // if (!user || !Object.keys(user).length) {
  //   return undefined
  // }
  //
  // return {
  //   email: user.email,
  // }
  return undefined
}

const getTenantData = (): TenantData | undefined => {
  // if (typeof getState !== 'function') {
  //   return undefined
  // }
  //
  // const user = getState().user
  //
  // if (!user || !Object.keys(user).length) {
  //   return undefined
  // }
  //
  // return {
  //   name: user.tenantName,
  // }
  return undefined
}

/**
 * Add message to the queue
 *
 * @param {Object} logObject
 */
const addLogToQueue = (logObject: LogObject): void => {
  // get logs queue
  const queue: LogObject[] = (localStorage.get('logs') || []) as LogObject[]

  // add new log object to the queue with offline flag
  queue.push({ ...logObject, offline: true })

  // update the offline queue
  localStorage.set('logs', queue)
}

/**
 * Clear cache - delete logs from local storage
 */
export const clearCache = (): void => {
  localStorage.clear('logs')
}

/**
 * Send queued messages (unset logs)
 *
 * @return {Promise}
 */
export const sendQueuedLogs = async (): Promise<void> => {
  // get stored logs (offline logs)
  const queue = (localStorage.get('logs') || []) as LogObject[]

  // clear stored logs (will try to resend the logs and will end up in the same queue if app is offline)
  clearCache()

  for (const logObject of queue) {
    /* eslint-disable @typescript-eslint/no-use-before-define */
    await log(logObject)
    /* eslint-enable @typescript-eslint/no-use-before-define */
  }
}

/**
 * Log message
 *
 * @return {Promise.<undefined>} superagent response
 */
const log = async (logParams: LogParams): Promise<boolean> => {
  const {
    level,
    message,
    params = {},
    offline = false,
    version = appVersion,
    sendQueuedMessages = false,
  } = logParams

  if (!url) {
    return false
  }

  // const state = getState()

  const logObject: LogObject = {
    level,
    module,
    site,
    environment,
    message,
    app,
    version,
    offline,
    createdAt: new Date().toISOString(),
    user: getUserData(),
    tenant: getTenantData(),
    client: {
      userAgent: navigator.userAgent,
    },
    params: {
      browserSessionId,
      sessionId,
      location: {
        pathname: window.location.hash.split('?')[0],
        search: window.location.hash.split('?')[1],
      },
      language: getLocale(),
      // state:
      //   level === 'error'
      //     ? JSON.stringify({
      //         ...state,
      //         // remove messges from logs
      //         intl: {
      //           ...state.intl,
      //           messages: [],
      //         },
      //         user: {
      //           ...state.user,
      //           accessToken: undefined,
      //         },
      //         roles: [],
      //       })
      //     : undefined,
      ...params,
    },
  }

  const authToken = getToken()
  if (!authToken) {
    /* eslint-disable no-console */
    console.error('Cannot send log: missing Authorization token')
    /* eslint-enable no-console */
    addLogToQueue(logObject)
    return false
  }

  try {
    // eslint-disable-next-line no-console
    // console.log(
    //   `${logObject.createdAt} ${logObject.level.toUpperCase()} ${
    //     logObject.message
    //   }: ${JSON.stringify(logObject.params)}`,
    // )
    await superagent
      .post(url)
      .set('content-type', 'application/json')
      .set('Authorization', authToken)
      .send(JSON.stringify(logObject))

    if (sendQueuedMessages) {
      sendQueuedLogs()
    }

    return true
  } catch (error) {
    // if offline - add log object to the queue
    if (!error.status) {
      addLogToQueue(logObject)
    } else {
      /* eslint-disable no-console */
      console.error(error)
      /* eslint-enable no-console */
    }
    return false
  }
}

/**
 * Log debug message
 */
export const debug = (
  message: string,
  params?: Record<string, unknown>,
): void => {
  log({ level: LogLevel.debug, message, params, sendQueuedMessages: true })
}

/**
 * Log info message
 */
export const info = (
  message: string,
  params?: Record<string, unknown>,
): void => {
  log({ level: LogLevel.info, message, params, sendQueuedMessages: true })
}

/**
 * Log error message
 */
export const error = (
  message: string,
  params?: Record<string, unknown>,
): void => {
  log({ level: LogLevel.error, message, params, sendQueuedMessages: true })
}

export default {
  debug,
  info,
  error,
}
